// extracted by mini-css-extract-plugin
export default {"panel":"iBZfUTZtayjDYItKhTBo","expanded":"jw0awNddIQkzrx7QC7p4","header":"E9RJ44dceHm7oezHExQ8","tab":"ME3P5ii_HhwTKuLxTQyR","content":"u6wkROzUG1sgey39jzbF"};